/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import InternalOrderModal from '../../components/Warehouse/InternalOrderModal';
import InternalOrderProgressModal from '../../components/Warehouse/InternalOrderProgressModal';
import BaseGrid from '../../components/Common/BaseGrid';
import { post } from '../../helpers/api_helper';

import { changeSidebarType } from '../../store/actions';

function InternalOrders(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const { t } = props;

  const [signal, setSignal] = useState(0);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalEntity, setEditModalEntity] = useState({
    reference: '', instructions: '', items: [], type: 'Tech Order',
  });
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [progressModalOrder, setProgressModalOrder] = useState(null);

  const editOrder = (order) => {
    setEditModalEntity(order);
    setEditModalOpen(true);
  };

  const onEditSuccess = () => {
    setSignal(signal + 1);
    setEditModalOpen(false);
    setEditModalEntity(null);
  };

  const showProgress = (order) => {
    setProgressModalOrder(order);
    setProgressModalOpen(true);
  };

  const deleteOrder = async (order) => {
    if (!window.confirm(t('Are you sure?'))) return;
    try {
      await post(`/api/warehouse/internalOrders/delete/${order.id}`);
      toastr.success(t('Order deleted'));
      setSignal(signal + 1);
    } catch (err) {
      toastr.error(t('Unable to delete order'));
    }
  };

  const markDelivered = async (order) => {
    if (!window.confirm(t('Mark this order as delivered?'))) return;
    try {
      await post(`/api/warehouse/internalOrders/${order.id}/mark-delivered`);
      toastr.success(t('Order marked delivered'));
      setSignal((currentSignal) => currentSignal + 1);
    } catch (err) {
      toastr.error(t('Unable to mark order delivered'));
    }
  };

  useEffect(() => {
    // props.changeSidebarType('default');
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="10">
            <Card>
              <CardBody>
                <BaseGrid
                  url="/api/warehouse/internalOrders"
                  shouldUpdate={signal}
                  className="table table-bordered table-striped"
                  create={() => {
                    editOrder({
                      reference: '', instructions: '', items: [], type: 'Tech Order',
                    });
                  }}
                  createText={t('Generate Order')}
                  config={
                  {
                    columns: {
                      id: {
                        label: 'ID',
                        sort: true,
                      },
                      type: {
                        label: 'Type',
                        sort: true,
                      },
                      reference: {
                        label: 'Reference',
                        sort: true,
                      },
                      user: {
                        label: 'Creator',
                        sort: true,
                      },
                      items: {
                        label: 'Items',
                        sort: false,
                        format: (x) => {
                          const items = x.map((y) => (y.inventory !== null ? y.inventory.part_number : `KIT-${y.stock_id}`));
                          return items.length > 0 ? items.join(', ') : 'none';
                        },
                      },
                      picked: {
                        label: 'Picked',
                        sort: false,
                        // eslint-disable-next-line react/no-unstable-nested-components
                        format: (y, order) => {
                          // eslint-disable-next-line max-len
                          const picked = order.items.reduce((a, itm) => a + (itm.pick_items ? itm.pick_items.reduce((b, pi) => b + pi.picked_qty + (pi.void * pi.qty), 0) : 0), 0);
                          const total = order.items.reduce((a, itm) => a + itm.qty, 0);
                          return (
                            <button type="button" className="btn btn-link p-0" onClick={() => showProgress(order)}>
                              {`${picked}/${total}`}
                            </button>
                          );
                        },
                      },
                      progress: {
                        label: 'Progress',
                        progress: {
                          value: (order) => {
                            // eslint-disable-next-line max-len
                            const picked = order.items.reduce((a, itm) => a + (itm.pick_items ? itm.pick_items.reduce((b, pi) => b + pi.picked_qty + (pi.void * pi.qty), 0) : 0), 0);
                            const total = order.items.reduce((a, itm) => a + itm.qty, 0);
                            return total === 0 ? 0 : (picked / total) * 100;
                          },
                        },
                      },
                      created_at: {
                        label: 'Created',
                        date: {
                          format: (date) => (moment(date).fromNow()),
                          timezone: process.env.REACT_APP_LOCAL_TZ,
                        },
                        sort: true,
                      },
                      actions: {
                        label: 'Actions',
                        actions: [
                          {
                            key: 'mark_delivered',
                            icon: 'mdi mdi-check-circle',
                            class: 'btn btn-sm btn-soft-success text-dark',
                            alt: 'Mark delivered',
                            click: markDelivered,
                            condition: (order) => order.fulfilled_at === null,
                          },
                          {
                            key: 'edit_order',
                            icon: 'mdi mdi-pencil',
                            class: 'btn btn-sm btn-soft-warning text-dark',
                            alt: 'Edit',
                            click: editOrder,
                          },
                          {
                            key: 'delete_order',
                            icon: 'mdi mdi-delete',
                            class: 'btn btn-sm btn-soft-danger text-dark',
                            alt: 'Delete',
                            click: deleteOrder,
                          },
                        ],
                      },
                    },
                    pagination: {
                      sort: 'id',
                      direction: 'desc',
                      perPage: 30,
                    },
                  }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <InternalOrderModal
          shown={editModalOpen}
          order={editModalEntity}
          onSuccess={onEditSuccess}
          onClose={() => { setEditModalOpen(false); setEditModalEntity(null); }}
        />
        <InternalOrderProgressModal
          shown={progressModalOpen}
          order={progressModalOrder}
          onClose={() => { setProgressModalOpen(false); setProgressModalOrder(null); }}
        />
      </div>
    </div>
  );
}

InternalOrders.defaultProps = {
  t: (x) => (x),
};

InternalOrders.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state) => ({ ...state.Layout });

export default connect(mapStateToProps, {
  changeSidebarType,
})(withTranslation()(InternalOrders));
